import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Seo } from '../../models/seo';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetaInformationService {

  apiUrl: string = environment.apiUrl;
  urlCDN: string = environment.cdnFilesStatic;

  constructor(
    private http: HttpClient,
    handler: HttpBackend
  ) { 
    this.http = new HttpClient(handler);
  }

  getMetaInformation(moduleParams: string, type: string): Observable<Seo> {
    let url: string = `${this.apiUrl}seo/${type}/${moduleParams}`;

    if (this.urlCDN && type === "pages" && moduleParams === "inicio") {
      url = `${this.urlCDN}siteJSON/admin-jelpit-com-api-seo-pages-inicio.json`;
    }
    return this.http.get<Seo>(url);
  }
}
